var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
import { apiInternalSprinklerProjectionReportsPath, exportCsvApiInternalSprinklerProjectionReportsPath, exportSummaryCsvApiInternalSprinklerProjectionReportsPath } from '@routes';
function buildBaseParams(filters) {
    const params = new URLSearchParams();
    // params.set('collapse_groups', String(filters.collapseGroups)); // re-enable with the collapse-groups control
    params.set('collapse_groups', 'true');
    if (filters.search)
        params.set('search', filters.search);
    if (filters.dateType)
        params.set('date_type', filters.dateType);
    if (filters.dateRange.startDate)
        params.set('start_date', filters.dateRange.startDate);
    if (filters.dateRange.endDate)
        params.set('end_date', filters.dateRange.endDate);
    filters.accountIds.forEach((id) => params.append('account_ids[]', String(id)));
    filters.buildingIds.forEach((id) => params.append('building_ids[]', String(id)));
    filters.territoryIds.forEach((id) => params.append('territory_ids[]', String(id)));
    filters.additionalTerritoryIds.forEach((id) => params.append('additional_territory_ids[]', String(id)));
    filters.systemIds.forEach((id) => params.append('system_ids[]', String(id)));
    return params;
}
export function fetchProjectionReport(filters_1) {
    return __awaiter(this, arguments, void 0, function* (filters, page = 1, perPage = 25, sortBy = null, sortDirection = 'asc') {
        const params = buildBaseParams(filters);
        params.set('page', String(page));
        params.set('per_page', String(perPage));
        if (sortBy)
            params.set('sort_by', sortBy);
        params.set('sort_direction', sortDirection);
        const response = yield api.get(`${apiInternalSprinklerProjectionReportsPath()}?${params.toString()}`);
        return response.data;
    });
}
function postExport(path, filters, sortBy, sortDirection, selectedIds, selectAll) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = buildBaseParams(filters);
        if (sortBy)
            params.set('sort_by', sortBy);
        params.set('sort_direction', sortDirection);
        if (selectAll) {
            params.set('all', 'true');
        }
        else if (selectedIds.length > 0) {
            selectedIds.forEach((id) => params.append('ids[]', String(id)));
        }
        const response = yield api.post(`${path()}?${params.toString()}`);
        return response.data;
    });
}
export function triggerExportCsv(filters, sortBy, sortDirection, selectedIds, selectAll) {
    return postExport(exportCsvApiInternalSprinklerProjectionReportsPath, filters, sortBy, sortDirection, selectedIds, selectAll);
}
export function triggerExportSummary(filters, sortBy, sortDirection, selectedIds, selectAll) {
    return postExport(exportSummaryCsvApiInternalSprinklerProjectionReportsPath, filters, sortBy, sortDirection, selectedIds, selectAll);
}
